import styled from 'styled-components';

export const BGWrap = styled.div`
  width: 100%;
  padding-top: ${({ width, height }) => `${(height / width) * 100}%`};
  border-top: none;
  border-bottom: none;
  box-sizing: border-box;
  background: url(${({ imgUrl }) => imgUrl}) center center no-repeat;
  background-size: cover;
  position: relative;
`;

export const YoutubeWrap = styled.div`
  position: absolute;
  width: 88.8%;
  height: 78.8%;
  top: 5.2%;
  left: 5.9%;
  > div {
    width: 100%;
    height: 100%;
  }
  iframe {
    width: 100%;
    height: 100%;
  }
`;

export const Btn = styled.button`
  position: absolute;
  top: 41.8%;
  left: 22%;
  width: 56%;
  height: 9.5%;
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;
`;
